import Skeleton from "react-loading-skeleton";
import { useCorporateActionPairs } from "../hooks/CorporateActionPairsContext";
import styled from "styled-components";
import moment from "moment";
import CorporateActionPairsGridRowActionCol from "./CorporateActionPairsGridRowActionCol";
import { DateDisplay } from "../../../components";
import toast from "react-hot-toast";
import { openConfirmModal } from "../../../components/modals/ConfirmModal";

const TableCell = styled.td`
    width: ${props => props.width}%;
    max-width: 50px;
    vertical-align: middle;
`;

const CorporateActionPairsGridRow = ({ index, data, style: { height, width } }) => {

    const { columns, setPairToEditId, deletePair } = useCorporateActionPairs();

    if (!data[index]) {
        return (
            <tr style={{ height, width }}>
                <td colSpan={columns.length}>
                    <Skeleton height={height - 10} />
                </td>
            </tr>
        );
    }

    const {
        pairId,
        actionDate,
        sedolIn,
        sedolOut,
        description
    } = data[index];

    const onDelete = () => {
        toast.promise(deletePair(pairId), {
            loading: "Deleting action pair...",
            error: "Unable to delete action pair.",
            success: () => {
                return "Action pair deleted!";
            }
        });
    };

    const showConfirmDeleteModal = () => {
        openConfirmModal({
            dialogTitle: "Delete Corporate Action Pair",
            message: `Are you sure you want to delete the pair Out: ${sedolOut && sedolIn ? `${sedolOut}, In: ${sedolIn}` : "this pair"}?`,
            confirmButtonText: "Delete",
            confirmButtonVariant: "danger"
        }).then(
            (proceed) => {
                if (proceed)
                    onDelete();
            }
        )
    }

    return <tr onDoubleClick={() => setPairToEditId(pairId)} style={{ height, width }}>
        <TableCell width={8.5}>{moment(actionDate).isValid() ? <DateDisplay>{actionDate}</DateDisplay> : <span className="px-2">-</span>}</TableCell>
        <TableCell width={8.5}>{sedolOut}</TableCell>
        <TableCell width={8.5}>{sedolIn}</TableCell>
        <TableCell width={72.5} className="text-truncate">{description}</TableCell>
        <TableCell align="right">
            <CorporateActionPairsGridRowActionCol 
                deleteFn={showConfirmDeleteModal}
                editFn={() => setPairToEditId(pairId)}
            />
        </TableCell>
    </tr>

};

export default CorporateActionPairsGridRow;